<template>
  <div>
     <v-container fluid>
      <span class="justify-center text-h5">
          {{ editedItem.name }}
      </span>
      <v-row>
        <v-col>
          <MPNResearchBatchV2 :itemId="$route.params.itemId"></MPNResearchBatchV2>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <MPNResearchDetailV2 :bomMpnResearchId="$route.params.itemId"></MPNResearchDetailV2>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MPNResearchBatchV2 from "@/components/MPNResearchV2/MPNResearchBatchV2";
import MPNResearchDetailV2 from "@/components/MPNResearchV2/MPNResearchDetailV2";
import BaseModal from "@/components/Base/BaseModal";
import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";

export default {
  name: 'MPNCheckingItem',
  props: ['itemId'],


  components: {
    MPNResearchBatchV2,
    MPNResearchDetailV2,
    BaseModal,
  },

  computed: {
    ...mapGetters('MPNResearch', []),
    ...mapFields('MPNResearch', ['loading', 'itemList', 'editedItem']),
  },

  created() {
    // window.addEventListener("resize", this.onResize)
  },
  destroyed() {
    // window.removeEventListener("resize", this.onResize);
  },

  methods: {
    ...mapActions('MPNResearch', ['fetchItem']),
  },

  async mounted() {
    // window.addEventListener("resize", this.onResize)
    await this.onResize()

    await this.fetchItem(this.$route.params.itemId)
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
</style>
